"use client";

import {
  initializeFaro,
  getWebInstrumentations,
  type Faro,
} from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

let faroInstance: Faro | null = null;

export function getFaro(): Faro | null {
  return faroInstance;
}

export function initFaro(): void {
  const collectorUrl = process.env.NEXT_PUBLIC_GRAFANA_FARO_COLLECTOR_URL;
  if (!collectorUrl || typeof window === "undefined") return;
  if (faroInstance) return;

  faroInstance = initializeFaro({
    url: collectorUrl,
    app: {
      name: "snowpad",
      version: process.env.NEXT_PUBLIC_APP_VERSION ?? "0.1.0",
      environment: process.env.NODE_ENV ?? "development",
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
    sessionTracking: {
      enabled: true,
      persistent: true,
    },
  });
}
